import { ANALYZE_WEBSITES_IMAGE, GEN_AI_IMAGE, IMPROVE_SEO_IMAGE, QuizSplitUseCaseGroup } from "./constants";
import type { UseCaseConfig } from "./types";

export const TITLE = "account.firstLand.modal.title";
export const MESSAGE_1 = "account.firstLand.modal.message.1";
export const MESSAGE_2 = "account.firstLand.modal.message.2";
export const BTN_TEXT = "account.firstLand.modal.btn.text";

export const WINCHER_TITLE = "account.firstLand.modal.wincher.title";
export const WINCHER_MESSAGE = "account.firstLand.modal.wincher.message";
export const WINCHER_MESSAGE_2 = "account.firstLand.modal.wincher.message.2";

export const TRACKING_VALUE = "You're now in";
export const WINCHER_TRACK_NAME = "wincher migration";
//TODO: automate calculating page name for tracking 1
export const getModalText = (quiz: QuizSplitUseCaseGroup, isCiPackage?: boolean): UseCaseConfig => {
    switch (quiz) {
        case QuizSplitUseCaseGroup.ANALYZE_WEBSITES:
            return {
                message1Bold: "account.firstLand.modal.analyze.website.msg1",
                message2Bold: "account.firstLand.modal.analyze.website.msg2",
                tracking1: "Website Analysis",
                tracking2: QuizSplitUseCaseGroup.ANALYZE_WEBSITES,
                image: ANALYZE_WEBSITES_IMAGE,
            };
        case QuizSplitUseCaseGroup.IMPROVE_SEO:
            return {
                message1Bold: isCiPackage
                    ? "account.firstLand.modal.analyze.website.msg1"
                    : "account.firstLand.modal.kw.research.msg1",
                message2Bold: "account.firstLand.modal.kw.research.new.msg2",
                tracking1: isCiPackage ? "Website Analysis" : "Keyword Research",
                tracking2: QuizSplitUseCaseGroup.IMPROVE_SEO,
                image: IMPROVE_SEO_IMAGE,
            };

        case QuizSplitUseCaseGroup.GEN_AI:
            return {
                message1Bold: "account.firstLand.modal.gen_ai.msg1",
                message2Bold: "account.firstLand.modal.gen_ai.msg2",
                tracking1: "AI Brand Visibility",
                tracking2: QuizSplitUseCaseGroup.GEN_AI,
                image: GEN_AI_IMAGE,
            };

        default:
            return {
                message1Bold: "",
                message2Bold: "",
                tracking1: "",
                tracking2: "",
            };
    }
};

export const getWincherModalText = (): UseCaseConfig => ({
    message1Bold: "",
    message2Bold: "",
    message: WINCHER_MESSAGE,
    message2: WINCHER_MESSAGE_2,
    tracking1: "Rank Tracker",
    tracking2: "Wincher Migration",
    image: ANALYZE_WEBSITES_IMAGE,
});
